// Function to collect service calls to controllers.
(function (api, $, undefined) {

    var VERBS = {
        POST: 'POST',
        GET: 'GET',
        DELETE: 'DELETE',
        PUT: 'PUT'
    };


    function invokeRest(url, data, verb) {
        return fetch(url, {
            body: JSON.stringify(data),
            cache: 'no-cache',
            credentials: 'include',
            headers: { 'content-type': 'application/json' },
            method: verb,
            mode: 'cors',
            redirect: 'manual', // manual, follow, error
            referrer: 'no-referrer' // client, no-referrer
        })
            .then(response => response.json()); // parses response to JSON
    }

    var rest = {
        post: function (url, data) {
            return invokeRest(url, data, VERBS.POST);
        },
        delete: function (url, data) {
            return invokeRest(url, data, VERBS.DELETE);
        }
    };


    api.initializeXsolla = function (token, sandbox, closefunction) {
        console.log('initializeXsolla');
        var options = {
            access_token: token,
            sandbox: sandbox,
            lightbox: {
                overlayOpacity: '0.2',
                height: '80%',
                spinner: 'round',
                closeByClick: false
            },
            childWindow: {
                target: '_parent'
            }
        };
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://static.xsolla.com/embed/paystation/1.0.7/widget.min.js';
        s.addEventListener('load', function (e) {
            XPayStationWidget.init(options);
            if (closefunction) {
                XPayStationWidget.on('close', closefunction);
            }
            XPayStationWidget.open();
        }, false);
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(s);
    },

    api.forgotPassword = function (form) {
        var viewModel = {
            EmailAddress: form.email
        };
        return rest.post('/account/forgot-password', viewModel);
    };

    api.resetPassword = function (form) {
        var viewModel = {
            Hash: form.hash,
            DateTime: form.date,
            Password: form.password,
            ConfirmPassword: form.confirm
        };
        return rest.post('/account/reset', viewModel);
    };

    api.cleanRegisterSession = function () {
        location.href = '/account/clean-register';
    };

})(window.api = window.api || {});



// WEBPACK FOOTER //
// ./Content/js/app/api.js